import React, { useState, useEffect } from "react";
import dtuLogo from "../../assets/dtulogo.png";
import "../../styles/header.css"; // Move header-specific styles here

const Header = ({ smoothScrollTo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Top Header */}
      <header className={`page-header ${isScrolled ? "scrolled" : ""}`}>
        <div className="header-content">
          <img
            src={dtuLogo}
            alt="DTU Logo"
            className="dtu-logo"
            onClick={(e) => {
              e.preventDefault();
              smoothScrollTo("home");
            }}
          />

          {/* Desktop Navigation */}
          <nav className="nav-links">
            <a href="/login">Login</a>
            <a
              href="#faculties"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("faculties");
              }}
            >
              Faculties
            </a>
            <a
              href="#digest"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("digest");
              }}
            >
              Research Digest
            </a>
            <a
              href="#echo"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("echo");
              }}
            >
              EchoesDTU
            </a>
            <a
              href="#alumni"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("alumni");
              }}
            >
              Alumni
            </a>
          </nav>

          {/* Hamburger Menu */}
          <button
            className={`hamburger-menu ${isMenuOpen ? "hidden" : ""}`}
            onClick={() => setIsMenuOpen(true)}
            aria-label="Open menu"
          >
            ☰
          </button>
        </div>
      </header>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${isMenuOpen ? "open" : ""}`}>
        <div className="sidebar-content">
          <button
            className="close-btn"
            onClick={() => setIsMenuOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
          <nav className="mobile-nav">
            <a href="/login" onClick={() => setIsMenuOpen(false)}>
              Login
            </a>
            <a
              href="#faculties"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("faculties");
                setIsMenuOpen(false);
              }}
            >
              Faculties
            </a>
            <a
              href="#digest"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("digest");
                setIsMenuOpen(false);
              }}
            >
              Research Digest
            </a>
            <a
              href="#echo"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("echo");
                setIsMenuOpen(false);
              }}
            >
              EchoesDTU
            </a>
            <a
              href="#alumni"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("alumni");
                setIsMenuOpen(false);
              }}
            >
              Alumni
            </a>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
